var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { addDays, endOfDay, startOfDay, startOfMonth, endOfMonth, addMonths, startOfWeek, endOfWeek, startOfQuarter, isSameDay, startOfYear, endOfYear } from 'date-fns';
import moment from 'moment';
var DAY_TEMPS_VALUE = {
    TODAY: "TODAY",
    YESTERDAY: "YESTERDAY",
    LAST_7_DAYS: "LAST_7_DAYS",
    LAST_30_DAYS: "LAST_30_DAYS",
    LAST_60_DAYS: "LAST_60_DAYS",
    LAST_90_DAYS: "LAST_90_DAYS",
    THIS_WEEK: "THIS_WEEK",
    LAST_WEEK: "LAST_WEEK",
    THIS_MONTH: "THIS_MONTH",
    LAST_MONTH: "LAST_MONTH",
    LAST_3_MONTH: "LAST_3_MONTH",
    CUSTOM: "CUSTOM",
    WEEK_TO_DATE: "WEEK_TO_DATE",
    MONTH_TO_DATE: "MONTH_TO_DATE",
    QUARTER_TO_DATE: "QUARTER_TO_DATE"
};
var startOfQuaterTmp = function () {
    var startOfQuaterOfCurentDate = moment().startOf('quarter').toDate();
    return startOfQuaterOfCurentDate;
};
var createDefineds = function (weekStartsOn) { return ({
    startOfWeek: startOfWeek(new Date(), { weekStartsOn: weekStartsOn }),
    endOfWeek: endOfWeek(new Date(), { weekStartsOn: weekStartsOn }),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7), { weekStartsOn: weekStartsOn }),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7), { weekStartsOn: weekStartsOn }),
    startOfNextWeek: startOfWeek(addDays(new Date(), 7), { weekStartsOn: weekStartsOn }),
    endOfNextWeek: endOfWeek(addDays(new Date(), 7), { weekStartsOn: weekStartsOn }),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    startOfNextMonth: startOfMonth(addMonths(new Date(), 1)),
    endOfNextMonth: endOfMonth(addMonths(new Date(), 1)),
    startOfYear: startOfYear(new Date()),
    endOfYear: endOfYear(new Date()),
    startOf7Days: startOfDay(addDays(new Date(), -7)),
    endOf7Days: endOfDay(addDays(new Date(), -1)),
    startOf30Days: startOfDay(addDays(new Date(), -30)),
    endOf30Days: endOfDay(addDays(new Date(), -1)),
    startOfWeekToDate: startOfWeek(new Date(), { weekStartsOn: weekStartsOn }),
    endOfWeekToDate: endOfDay(addDays(new Date(), -1)),
    startOfMonthToDate: startOfMonth(new Date()),
    endOfMonthToDate: endOfDay(addDays(new Date(), -1)),
    startOfQuaterToDate: startOfQuarter(new Date(startOfQuaterTmp())),
    endOfQuaterToDate: endOfDay(addDays(new Date(), -1)),
    firstDate: new Date("2018-01-01"),
    now: new Date()
}); };
var staticRangeHandler = {
    range: {},
    isSelected: function (range) {
        var that = this;
        var definedRange = that.range();
        return (isSameDay(range.startDate, definedRange.startDate) &&
            isSameDay(range.endDate, definedRange.endDate));
    },
};
export function createStaticRanges(ranges) {
    return ranges.map(function (range) { return (__assign(__assign({}, staticRangeHandler), range)); });
}
export default (function (locale) {
    var defineds = createDefineds(locale.options.weekStartsOn);
    return createStaticRanges([
        // {
        //   label: 'Today',
        //   range: () => ({
        //     startDate: defineds.startOfToday,
        //     endDate: defineds.endOfToday,
        //   }),
        // },
        {
            label: 'Yesterday',
            value: DAY_TEMPS_VALUE.YESTERDAY,
            range: function () { return ({
                startDate: defineds.startOfYesterday,
                endDate: defineds.endOfYesterday,
            }); },
        },
        // {
        //   label: 'This Week',
        //   range: () => ({
        //     startDate: defineds.startOfWeek,
        //     endDate: defineds.endOfWeek,
        //   }),
        // },
        {
            label: 'Last 7 Days',
            value: DAY_TEMPS_VALUE.LAST_7_DAYS,
            range: function () { return ({
                startDate: defineds.startOf7Days,
                endDate: defineds.endOf7Days,
            }); },
        },
        {
            label: 'Last Week',
            value: DAY_TEMPS_VALUE.LAST_WEEK,
            range: function () { return ({
                startDate: defineds.startOfLastWeek,
                endDate: defineds.endOfLastWeek,
            }); },
        },
        {
            label: 'Last 30 Days',
            value: DAY_TEMPS_VALUE.LAST_30_DAYS,
            range: function () { return ({
                startDate: defineds.startOf30Days,
                endDate: defineds.endOf30Days,
            }); },
        },
        // {
        //   label: 'This Month',
        //   range: () => ({
        //     startDate: defineds.startOfMonth,
        //     endDate: defineds.endOfMonth,
        //   }),
        // },
        {
            label: 'Last Month',
            value: DAY_TEMPS_VALUE.LAST_MONTH,
            range: function () { return ({
                startDate: defineds.startOfLastMonth,
                endDate: defineds.endOfLastMonth,
            }); },
        },
        {
            label: 'Week To Date',
            value: DAY_TEMPS_VALUE.WEEK_TO_DATE,
            range: function () { return ({
                startDate: defineds.startOfWeekToDate,
                endDate: defineds.endOfWeekToDate,
            }); },
        },
        {
            label: 'Month To Date',
            value: DAY_TEMPS_VALUE.MONTH_TO_DATE,
            range: function () { return ({
                startDate: defineds.startOfMonthToDate,
                endDate: defineds.endOfMonthToDate,
            }); },
        },
        {
            label: 'Quarter To Date',
            value: DAY_TEMPS_VALUE.QUARTER_TO_DATE,
            range: function () { return ({
                startDate: defineds.startOfQuaterToDate,
                endDate: defineds.endOfQuaterToDate,
            }); },
        }
    ]);
});
export var generateLabelRange = function (start, end, locale) {
    var defineds = createDefineds(locale.options.weekStartsOn);
    var defaultRanges = [
        {
            label: 'Today',
            duration: {
                startDate: moment(defineds.startOfToday).format('YYYYMMDD'),
                endDate: moment(defineds.endOfToday).format('YYYYMMDD'),
            }
        },
        {
            label: 'Yesterday',
            duration: {
                startDate: moment(defineds.startOfYesterday).format('YYYYMMDD'),
                endDate: moment(defineds.endOfYesterday).format('YYYYMMDD'),
            }
        },
        {
            label: 'This Week',
            duration: {
                startDate: moment(defineds.startOfWeek).format('YYYYMMDD'),
                endDate: moment(defineds.endOfWeek).format('YYYYMMDD')
            }
        },
        {
            label: 'Last 7 Days',
            duration: {
                startDate: moment(defineds.startOf7Days).format('YYYYMMDD'),
                endDate: moment(defineds.endOf7Days).format('YYYYMMDD')
            }
        },
        {
            label: 'Last Week',
            duration: {
                startDate: moment(defineds.startOfLastWeek).format('YYYYMMDD'),
                endDate: moment(defineds.endOfLastWeek).format('YYYYMMDD')
            }
        },
        {
            label: 'Last 30 Days',
            duration: {
                startDate: moment(defineds.startOf30Days).format('YYYYMMDD'),
                endDate: moment(defineds.endOf30Days).format('YYYYMMDD')
            }
        },
        {
            label: 'This Month',
            duration: {
                startDate: moment(defineds.startOfMonth).format('YYYYMMDD'),
                endDate: moment(defineds.endOfMonth).format('YYYYMMDD')
            }
        },
        {
            label: 'Last Month',
            duration: {
                startDate: moment(defineds.startOfLastMonth).format('YYYYMMDD'),
                endDate: moment(defineds.endOfLastMonth).format('YYYYMMDD')
            }
        },
        {
            label: 'Week To Date',
            duration: {
                startDate: moment(defineds.startOfWeekToDate).format('YYYYMMDD'),
                endDate: moment(defineds.endOfWeekToDate).format('YYYYMMDD')
            }
        },
        {
            label: 'Month To Date',
            duration: {
                startDate: moment(defineds.startOfMonthToDate).format('YYYYMMDD'),
                endDate: moment(defineds.endOfMonthToDate).format('YYYYMMDD')
            }
        },
        {
            label: 'Quarter To Date',
            duration: {
                startDate: moment(defineds.startOfQuaterToDate).format('YYYYMMDD'),
                endDate: moment(defineds.endOfQuaterToDate).format('YYYYMMDD')
            }
        }
    ];
    var foundRangeDate = defaultRanges.find(function (range) { return range.duration.startDate == start && range.duration.endDate == end; });
    return foundRangeDate ? foundRangeDate.label : "";
};
export function staticRangesForMedian(locale) {
    var defineds = createDefineds(locale.options.weekStartsOn);
    return createStaticRanges([
        {
            label: 'All Time',
            range: function () { return ({
                startDate: defineds.firstDate,
                endDate: defineds.now,
            }); },
        },
        {
            label: 'Last 7 Days',
            range: function () { return ({
                startDate: defineds.startOf7Days,
                endDate: defineds.endOf7Days,
            }); },
        },
        {
            label: 'Last Week',
            range: function () { return ({
                startDate: defineds.startOfLastWeek,
                endDate: defineds.endOfLastWeek,
            }); },
        },
        {
            label: 'Last 30 Days',
            range: function () { return ({
                startDate: defineds.startOf30Days,
                endDate: defineds.endOf30Days,
            }); },
        },
        {
            label: 'Last Month',
            range: function () { return ({
                startDate: defineds.startOfLastMonth,
                endDate: defineds.endOfLastMonth,
            }); },
        },
        {
            label: 'Week To Date',
            range: function () { return ({
                startDate: defineds.startOfWeekToDate,
                endDate: defineds.endOfWeekToDate,
            }); },
        },
        {
            label: 'Month To Date',
            range: function () { return ({
                startDate: defineds.startOfMonthToDate,
                endDate: defineds.endOfMonthToDate,
            }); },
        },
        {
            label: 'Quarter To Date',
            range: function () { return ({
                startDate: defineds.startOfQuaterToDate,
                endDate: defineds.endOfQuaterToDate,
            }); },
        }
    ]);
}
export function staticRangesForAlert(locale) {
    var defineds = createDefineds(locale.options.weekStartsOn);
    return createStaticRanges([
        {
            label: 'Today',
            range: function () { return ({
                startDate: defineds.startOfToday,
                endDate: defineds.endOfToday,
            }); },
        },
        {
            label: 'This Week',
            range: function () { return ({
                startDate: defineds.startOfWeek,
                endDate: defineds.endOfWeek,
            }); },
        },
        {
            label: 'This Month',
            range: function () { return ({
                startDate: defineds.startOfMonth,
                endDate: defineds.endOfMonth,
            }); },
        },
        {
            label: 'Next Week',
            range: function () { return ({
                startDate: defineds.startOfNextWeek,
                endDate: defineds.endOfNextWeek,
            }); },
        },
        {
            label: 'Next Month',
            range: function () { return ({
                startDate: defineds.startOfNextMonth,
                endDate: defineds.endOfNextMonth,
            }); },
        },
        {
            label: 'This Year',
            range: function () { return ({
                startDate: defineds.startOfYear,
                endDate: defineds.endOfYear,
            }); },
        }
    ]);
}
export function staticRangesActivitiveStreamForGAM(locale) {
    var defineds = createDefineds(locale.options.weekStartsOn);
    return createStaticRanges([
        {
            label: 'Today',
            range: function () { return ({
                startDate: defineds.startOfToday,
                endDate: defineds.endOfToday,
            }); },
        },
        {
            label: 'Yesterday',
            range: function () { return ({
                startDate: defineds.startOfYesterday,
                endDate: defineds.endOfYesterday,
            }); },
        },
        {
            label: 'This Week',
            range: function () { return ({
                startDate: defineds.startOfWeek,
                endDate: defineds.endOfWeek,
            }); },
        },
        {
            label: 'Last 7 Days',
            range: function () { return ({
                startDate: defineds.startOf7Days,
                endDate: defineds.endOf7Days,
            }); },
        },
        {
            label: 'Last Week',
            range: function () { return ({
                startDate: defineds.startOfLastWeek,
                endDate: defineds.endOfLastWeek,
            }); },
        },
        {
            label: 'Last 30 Days',
            range: function () { return ({
                startDate: defineds.startOf30Days,
                endDate: defineds.endOf30Days,
            }); },
        },
        {
            label: 'This Month',
            range: function () { return ({
                startDate: defineds.startOfMonth,
                endDate: defineds.endOfMonth,
            }); },
        },
        {
            label: 'Last Month',
            range: function () { return ({
                startDate: defineds.startOfLastMonth,
                endDate: defineds.endOfLastMonth,
            }); },
        },
        {
            label: 'Week To Date',
            range: function () { return ({
                startDate: defineds.startOfWeekToDate,
                endDate: defineds.endOfWeekToDate,
            }); },
        },
        {
            label: 'Month To Date',
            range: function () { return ({
                startDate: defineds.startOfMonthToDate,
                endDate: defineds.endOfMonthToDate,
            }); },
        },
        {
            label: 'Quarter To Date',
            range: function () { return ({
                startDate: defineds.startOfQuaterToDate,
                endDate: defineds.endOfQuaterToDate,
            }); },
        }
    ]);
}
